import React, { FC } from 'react';
import { CreateAccount } from 'features/create-account';
import { StyledLandingContainer } from 'shared/ui/styled-components';
import { Locale } from 'shared/ui/locale';
import { StyledPromoContainer, StyledText } from './styled';

export const Promo: FC<{ signUp: string }> = ({ signUp }) => (
    <StyledLandingContainer $align="center" $justify="center" $padding="3em 0 3.5em" $width="100%">
        <StyledPromoContainer>
            <StyledText type="BTM3">
                <Locale localizationKey="Landing.Landing_Portal_Description_bottom" />
            </StyledText>
            <CreateAccount signUpUrl={signUp} testId="signUpBottom" />
        </StyledPromoContainer>
    </StyledLandingContainer>
);
